import { getToken } from "firebase/messaging";
import { doc, setDoc } from "firebase/firestore";
import { messaging, db, auth, VAPID_KEY } from "../firebase/config";

export const saveFcmTokenToFirestore = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("🚫 Notification permission not granted");
      return;
    }

    const currentToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });

    if (currentToken && auth.currentUser) {
      const uid = auth.currentUser.uid;
      const userRole = auth.currentUser.role || "customer"; // Default to customer

      await setDoc(doc(db, "fcm_tokens", uid), {
        token: currentToken,
        role: userRole,
        updatedAt: new Date(),
        userEmail: auth.currentUser.email,
        userName: auth.currentUser.displayName || "",
      });

      console.log("✅ FCM Token saved to Firestore:", currentToken);
      return currentToken;
    }
  } catch (err) {
    console.error("❌ Error getting FCM token:", err);
  }
};

// Legacy function for backward compatibility
export const requestAndSaveToken = async (user) => {
  return saveFcmTokenToFirestore();
};
